// CloudinaryUploadManager.js
import { uploadToCloudinary } from './CloudinaryUpload';

export async function uploadAllAssets(bakeryCatalogueData, userId) {
  try {
    const uploadPromises = [];
    const uploadedUrls = {};

    // Upload background image if it's a data URL
    if (bakeryCatalogueData.backgroundImage && bakeryCatalogueData.backgroundImage.startsWith('data:')) {
      uploadPromises.push(
        uploadToCloudinary(bakeryCatalogueData.backgroundImage, { userId })
          .then(result => {
            uploadedUrls.backgroundImage = result.url;
          })
          .catch(error => {
            console.error('Error uploading background image:', error);
            throw error;
          })
      );
    } else {
      uploadedUrls.backgroundImage = bakeryCatalogueData.backgroundImage;
    }

    // Upload thumbnails
    uploadedUrls.thumbnails = [];
    for (let i = 0; i < bakeryCatalogueData.thumbnails.length; i++) {
      const thumb = bakeryCatalogueData.thumbnails[i];
      if (thumb && thumb.startsWith('data:')) {
        uploadPromises.push(
          uploadToCloudinary(thumb, { userId })
            .then(result => {
              uploadedUrls.thumbnails[i] = result.url;
            })
            .catch(error => {
              console.error(`Error uploading thumbnail ${i}:`, error);
              throw error;
            })
        );
      } else {
        uploadedUrls.thumbnails[i] = thumb;
      }
    }

    // Wait for all uploads to complete
    await Promise.all(uploadPromises);
    
    return {
      ...bakeryCatalogueData,
      backgroundImage: uploadedUrls.backgroundImage,
      thumbnails: uploadedUrls.thumbnails
    };
  } catch (error) {
    console.error('Error uploading assets:', error);
    throw new Error(`Failed to upload images: ${error.message}`);
  }
}